import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { isDropdownOpenFlag } from "src/thunks/dashboard";
import Calendar from 'react-calendar';
import Moment from "moment";
import { extendMoment } from 'moment-range';
import _ from "lodash";
import { getMonthWeeksWithDates } from "src/constant";

const moment = extendMoment(Moment);

let monthData = [
    { name: "JAN", id: 0 },
    { name: "FEB", id: 1 },
    { name: "MAR", id: 2 },
    { name: "APR", id: 3 },
    { name: "MAY", id: 4 },
    { name: "JUN", id: 5 },
    { name: "JUL", id: 6 },
    { name: "AUG", id: 7 },
    { name: "SEP", id: 8 },
    { name: "OCT", id: 9 },
    { name: "NOV", id: 10 },
    { name: "DEC", id: 11 },
]

const Quators = [
    { id: 1, name: "Q1(JAN - MAR)", months: [1, 2, 3] },
    { id: 2, name: "Q2 (APR - JUN)", months: [4, 5, 6] },
    { id: 3, name: "Q3 (JUL - SEP)", months: [7, 8, 9] },
    { id: 4, name: "Q4 (OCT - DEC)", months: [10, 11, 12] }
]
export const ReportsCalenderDropdown = ({ handleChange, selectedDateFilterDropdownValue, ...props }) => {
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();
    const [valueFrom, setDateValueFrom] = useState(new Date());
    const [open, setOpen] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [isDateRange, setIsDateRange] = useState(false);
    const [weekArrayToDisplay, setWeekArrayToDisplay] = useState([]);
    const [YearArrayToDisplay, setYearArrayToDisplay] = useState([]);

    const [selectedWeek, setSelectedWeek] = useState("week1")
    const [selectedQuarter, setSelectedQuarter] = useState();
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1)
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear())

    const getCurrentWeekArray = (selectedMonth, selectedYear) => {
        const year = parseInt(selectedYear);
        const month = parseInt(selectedMonth);
        const weeksList = getMonthWeeksWithDates(year, month);
        setWeekArrayToDisplay([...weeksList])
        return weeksList
    }


    useEffect(() => {
        // dispatch(setSelectedReportsDateObject({
        //     type: selectedDateFilterDropdownValue,
        //     week: selectedWeek,
        //     month: selectedMonth,
        //     year: selectedYear,
        //     startDate: startDate,
        //     quarter: selectedQuarter,
        //     endDate: endDate,
        //     isDateRange: isDateRange
        // }));
    }, [startDate, endDate, selectedDateFilterDropdownValue])


    useEffect(() => {
        const date = new Date();
        const currentMonth = date.getMonth();
        const currentQuarter = Math.floor(currentMonth / 3) + 1;
        setSelectedQuarter(currentQuarter);
    }, [])


    useEffect(() => {

        let yearArrayDisplay = [];

        const minOffset = 0;
        const maxOffset = 10;
        const thisYear = new Date().getFullYear();

        for (let i = minOffset; i <= maxOffset; i++) {
            const year = thisYear - i;
            yearArrayDisplay = [...yearArrayDisplay, { value: year, label: year }]
        }
        setYearArrayToDisplay(yearArrayDisplay)

        const [formattedMonthStartDate, formattedMonthEndDate] = MonthDates(selectedYear, selectedMonth)
        const [formattedYearStartDate, formattedYearEndDate] = YearDates(selectedYear)
        const [formattedQuarterStartDate, formattedQuarterEndDate] = QuarterDates(selectedYear, parseInt(selectedQuarter))
        if (selectedDateFilterDropdownValue == "Daily") {
            setStartDate((moment(valueFrom).format('YYYY-MM-DD')));
            setEndDate(null);
            setIsDateRange(false);
        } else if (selectedDateFilterDropdownValue == "Monthly") {
            setIsDateRange(true);
            setStartDate(formattedMonthStartDate);
            setEndDate(formattedMonthEndDate)
        }
        else if (selectedDateFilterDropdownValue == "Yearly") {
            setIsDateRange(true);
            setStartDate(formattedYearStartDate);
            setEndDate(formattedYearEndDate)
        } else if (selectedDateFilterDropdownValue == "Quarterly") {
            setIsDateRange(true);
            setStartDate(formattedQuarterStartDate);
            setEndDate(formattedQuarterEndDate)
        } else {
            let data = getCurrentWeekArray(selectedMonth, selectedYear);
            let weekSelected = _.find(data, (d) => d.label === "Week1")
            setStartDate(weekSelected?.startDate);
            setEndDate(weekSelected?.endDate)
        }

    }, [selectedYear, selectedMonth, selectedDateFilterDropdownValue, valueFrom, selectedQuarter])


    function MonthDates(year, month) {

        // Create a new Date object with the given year and month
        const startDate = moment(`${parseInt(month) + 1}-1-${year}`);
        // Format the start and end dates
        const formattedMonthStartDate = moment(startDate).startOf('month').format('YYYY-MM-DD');
        const formattedMonthEndDate = moment(startDate).endOf("month").format('YYYY-MM-DD');

        return [formattedMonthStartDate, formattedMonthEndDate]
    }

    function YearDates(year) {
        // Create a new Date object with the given year
        const startDate = new Date(year, 0, 1);
        const endDate = new Date(year, 11, 31);
        // Format the start and end dates
        const formattedYearStartDate = moment(startDate).format('YYYY-MM-DD');
        const formattedYearEndDate = moment(endDate).format('YYYY-MM-DD');
        return [formattedYearStartDate, formattedYearEndDate]

    }

    function QuarterDates(year, quarter) {
        const startDate = new Date(year, (quarter - 1) * 3, 1);
        const endDate = new Date(year, quarter * 3, 0);

        const formattedQuarterStartDate = moment(startDate).format('YYYY-MM-DD');
        const formattedQuarterEndDate = moment(endDate).format('YYYY-MM-DD');

        return [formattedQuarterStartDate, formattedQuarterEndDate]
    }

    useEffect(() => {
        dispatch(isDropdownOpenFlag(open))
    }, [open])

    const handleDropdownValueChange = (value) => {
        handleChange(value)
        if (value === "Weekly") {
            getCurrentWeekArray()
        }
    }

    const handleYearDropdownChange = (e) => {
        setSelectedYear(e.target.value)
    }

    const handleMonthDropdownChange = (e) => {
        setSelectedMonth(parseInt(e.target.value))
        setSelectedWeek("Week1")
    }

    const handleWeekDropdownChange = (value) => {
        setSelectedWeek(value)
        const weekSelected = _.find(weekArrayToDisplay, (d) => d.label === value)
        setStartDate(weekSelected?.startDate);
        setEndDate(weekSelected?.endDate)
    }

    const handleQuarterDropdownChange = (e) => {
        setSelectedQuarter(e.target.value)
    }

    const handleFromDateChange = (date) => {
        setDateValueFrom(date);
    }


    const onButton = () => {
        {
            setOpen((prevOpen) => !prevOpen)
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const getWeekComponent = () => {
        if (selectedDateFilterDropdownValue == "Weekly") {
            if (weekArrayToDisplay?.length > 0) {
                return <div className="row">
                    <div className="col-md-8">
                        <select className="form-select year-dropdown-reports-style" value={selectedWeek}
                            aria-label="Default select example"
                            onChange={({ target }) => handleWeekDropdownChange(target.value)}>
                            {weekArrayToDisplay && weekArrayToDisplay[0] && weekArrayToDisplay.map((week) => {
                                return (
                                    <React.Fragment key={week.value}>
                                        <option key={week.value} value={week.label}>{week.label}</option>
                                    </React.Fragment>
                                )
                            })}
                        </select>

                    </div>
                    <div className="col-md-4">
                    </div>
                </div>
            } else {
                return <></>
                return <>Week is in present so yoy can see report of this month week</>
            }
        }
    }

    const getMonthComponent = () => {
        let validMonth = monthData
        if (["Weekly", "Monthly"].includes(selectedDateFilterDropdownValue)) {
            let getcurrentMonth = moment().get("month")
            let getcurrentYear = moment().get("year")
            if (getcurrentYear <= selectedYear) {
                validMonth = _.filter(validMonth, (d) => ((selectedDateFilterDropdownValue === "Weekly" && d.id < getcurrentMonth) || (selectedDateFilterDropdownValue === "Monthly" && d.id < getcurrentMonth)))
            }
        }

        if (["Weekly", "Monthly"].includes(selectedDateFilterDropdownValue)) {
            return <div className="col-md-6">
                <select className="form-select year-dropdown-reports-style" aria-label="Default select example" value={selectedMonth}
                    onChange={(e) => handleMonthDropdownChange(e)}>
                    {
                        validMonth.map((d) => {
                            return <option value={d.id}>{d.name}</option>
                        })
                    }
                </select>
            </div>
        }
    }

    const getQuatorList = () => {
        let filterQuators = Quators
        let getcurrentYear = moment().get("year")
        if (getcurrentYear <= selectedYear) {
            let newQuator = []
            let getcurrentMonth = moment().get("month")
            _.map(filterQuators, (d) => {
                let lastMonthOfQuator = d.months[d.months?.length - 1]
                if (lastMonthOfQuator < getcurrentMonth) {
                    newQuator = [...newQuator, { ...d }]
                }
            })
            filterQuators = newQuator
        }

        if (selectedDateFilterDropdownValue == "Quarterly") {
            return <div className="row">
                <div className="col-md-10">
                    <select className="form-select year-dropdown-reports-style" value={selectedQuarter}
                        aria-label="Default select example"
                        onChange={(e) => handleQuarterDropdownChange(e)}
                    >
                        {
                            _.map(filterQuators, (d) => {
                                return <option value={d.id}>{d.name}</option>
                            })
                        }
                    </select>

                </div>
                <div className="col-md-2">
                </div>
            </div>
        }

    }

    return (
        <>
            <div ref={dropdownRef}>
                <div style={{ flex: 1, color: "white" }}>
                    <div className="wrapper">
                        <div className="header-div d-flex flex-row justify-content-between" onClick={() => onButton()}>
                            {selectedDateFilterDropdownValue == "Daily" ?
                                <span>DAILY {moment(startDate).format("DD-MMM-YYYY")}</span> :
                                <span>{moment(startDate).format("DD-MMM-YYYY")} To {moment(endDate).format("DD-MMM-YYYY")}</span>
                            }
                            {open ? (
                                <span>
                                    <i className="bi bi-chevron-up chevron-up-arrow"></i>
                                </span>
                            ) : (
                                <span>
                                    <i className="bi bi-chevron-down chevron-down-arrow"></i>
                                </span>
                            )}

                        </div>
                        {open &&
                            (
                                <>
                                    <div className="calendar-dropdown-content-reports">
                                        <select className="form-select reports-date-dropdown-header-style" value={selectedDateFilterDropdownValue}
                                            aria-label="Default select example"
                                            onChange={({ target }) => handleDropdownValueChange(target.value)}>
                                            <option value="Daily">DAILY</option>
                                            <option value="Weekly">WEEKLY</option>
                                            <option value="Monthly">MONTHLY</option>
                                            <option value="Quarterly">QUARTERLY</option>
                                            <option value="Yearly">YEARLY</option>
                                        </select>
                                        {selectedDateFilterDropdownValue == "Daily" &&
                                            <Calendar className="calendar-style-for-goodsin-and-dispatch" onChange={(date) => handleFromDateChange(date)} value={valueFrom} />
                                        }
                                        {["Weekly", "Monthly", "Yearly", "Quarterly"].includes(selectedDateFilterDropdownValue) ?
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <select className="form-select year-dropdown-reports-style" aria-label="Default select example" value={selectedYear}
                                                        onChange={(e) => handleYearDropdownChange(e)}>


                                                        {YearArrayToDisplay && YearArrayToDisplay[0] && YearArrayToDisplay.map((year, index) => {
                                                            return (
                                                                <React.Fragment key={index}>
                                                                    <option value={year.value}>{year.label}</option>
                                                                </React.Fragment>
                                                            )
                                                        })}                                                
                                                        </select>
                                                </div>
                                                {getMonthComponent()}
                                            </div> : ""}

                                        {getWeekComponent()}
                                        {getQuatorList()}
                                    </div>
                                </>
                            )}



                    </div>
                </div>
            </div>

        </>
    )
}